module.exports = __webpack_public_path__ + "7711602f92dc83fb3b1d67695c72914d.svg";